import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export default function isEmployeeTerminated(terminatedOn: string | undefined | null) {
  if (!terminatedOn) return false
  return stringToDate(terminatedOn, 'backend').isBefore(moment(), 'day')
}
